import { render, staticRenderFns } from "./ProductRow.vue?vue&type=template&id=2419c9da&scoped=true&"
import script from "./ProductRow.vue?vue&type=script&lang=js&"
export * from "./ProductRow.vue?vue&type=script&lang=js&"
import style0 from "./ProductRow.vue?vue&type=style&index=0&id=2419c9da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2419c9da",
  null
  
)

export default component.exports